import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'produtoFilter'
})
export class ProdutoFilterPipe implements PipeTransform {
  transform(produtos: any[], nome: string, categoria: string, status: string): any[] {
    if (!produtos) return [];
    
    return produtos.filter(produto => {
      // Filtro por nome
      if (nome && !produto.nome.toLowerCase().includes(nome.toLowerCase())) return false;
      
      // Filtro por categoria
      if (categoria && produto.categoria !== categoria) return false;
      
      // Filtro por status
      if (status && produto.status !== status) return false;
      
      return true;
    });
  }
} 